<!--
 * @Author:
 * @Description: 对象信息
-->
<template>
  <div class="h-full pt-10px pb-10px">
    <TableButtonGroup v-model="activeTab" :list="menuList" @btn-click="tabChange">
    </TableButtonGroup>
    <!-- 基本属性 -->
    <div v-if="activeTab === '属性'" class="pt-10px overflow-auto h-[calc(100%-48px)] 1">
      <div class="flex justify-start item-start mb-10px" v-if="classTypeTableData.length > 0">
        <CategoryTitle class="mt-5px mb-10px" title="基本属性"></CategoryTitle>
      </div>
      <div class="mb-10px text-white" v-if="classTypeTableData.length > 0">
        <el-row class="flex" v-for="(item, index) in classTypeTableData" :key="index">
          <el-col :span="8">
            <div class="text-[#c3c3c3] text-right">{{ item.name }}：</div>
          </el-col>
          <el-col :span="16">
            <el-tooltip
              :content="item.value"
              placement="top"
              :open-delay="500"
              :disabled="!item.value"
            >
              <div class="flex-1 truncate">{{ item.value }}</div>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <div class="mb-10px" v-for="(value, key, index) in dynamicTableGroupData" :key="index">
        <div
          v-if="
            value.filter((e) => {
              return e.show === true
            }).length > 0
          "
        >
          <CategoryTitle class="mt-5px mb-10px" :title="key"></CategoryTitle>
          <div class="mb-10px text-white">
            <el-row class="flex" v-for="(cItem, cIndex) in value" :key="cIndex">
              <el-col :span="8">
                <div v-if="cItem.show" class="text-[#c3c3c3] text-right">{{ cItem.name }}：</div>
              </el-col>
              <el-col :span="16">
                <el-tooltip
                  v-if="cItem.show"
                  :content="cItem.value"
                  placement="top"
                  :open-delay="500"
                  :disabled="!cItem.value"
                >
                  <div class="flex-1 truncate">{{ cItem.value }}</div>
                </el-tooltip>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="mb-10px text-white" v-if="pointDataList.length">
        <CategoryTitle class="mt-5px mb-10px" title="测点"></CategoryTitle>
        <InfiniteScroll
          :deviation="10"
          class="h-375px overflow-hidden"
          direction="Y"
          :num="pointDataList.length"
          :limit="4"
          :speed="0.5"
          ref="infiniteScrollRef"
          @reset="resetScrollHeight"
        >
          <div class="w-full">
            <div
              class="point-item-bg w-full mb-3 py-2 cursor-pointer"
              v-for="(item, index) in pointDataList"
              :key="index"
              @click="handlePointClick(item)"
            >
              <el-row
                class="flex"
                v-for="(pointDataHeaderItem, pointDataHeaderIndex) in pointDataHeader"
                :key="pointDataHeaderIndex"
              >
                <el-col :span="8">
                  <div class="text-[#c3c3c3] text-right">{{ pointDataHeaderItem[1] }}：</div>
                </el-col>
                <el-col :span="16">
                  <el-tooltip
                    :content="item[pointDataHeaderItem[0]]"
                    placement="top"
                    :open-delay="500"
                    :disabled="!item[pointDataHeaderItem[0]]"
                  >
                    <div class="flex-1 truncate">{{ item[pointDataHeaderItem[0]] }}</div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </div>
    <!-- 关联文档 -->
    <div v-if="activeTab === '关联文档'" class="pt-10px overflow-auto h-[calc(100%-48px)] 2">
      <div v-for="(item, index) in assocFilesList" :key="index">
        <div class="flex justify-start item-start mb-10px">
          <CategoryTitle class="mt-5px mb-10px" :title="item.nodeName"></CategoryTitle>
        </div>
        <div class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]">
          <div class="flex" v-for="(cItem, cIndex) in item.childrenNodes" :key="cIndex">
            <el-tooltip :content="cItem.fileName" placement="top" :open-delay="500">
              <div class="flex-1 truncate">{{ cItem.fileName }}</div>
            </el-tooltip>
            <div class="flex">
              <el-tooltip content="弹窗" placement="top" :open-delay="500">
                <img
                  src="../../../assets/images/objInfo/dialog.png"
                  alt=""
                  @click="openDialog(cItem)"
                />
              </el-tooltip>
              <el-tooltip content="侧边弹窗" placement="top" :open-delay="500">
                <img
                  src="../../../assets/images/objInfo/split_screen.png"
                  alt=""
                  @click="splitScreen(cItem)"
                />
              </el-tooltip>
              <el-tooltip
                v-if="splitShow"
                class="ml-2px"
                content="分屏"
                placement="top"
                :open-delay="500"
              >
                <img
                  src="../../../assets/images/objInfo/split.png"
                  alt=""
                  @click="realSplitScreen(cItem)"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关联对象 -->
    <div v-if="activeTab === '关联对象'" class="pt-10px overflow-auto h-[calc(100%-48px)]">
      <!-- 上级对象 -->
      <div class="flex justify-start item-start mb-10px" v-if="parentObject.length > 0">
        <CategoryTitle class="mt-5px mb-10px" title="上级对象"></CategoryTitle>
      </div>
      <div
        class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]"
        v-if="parentObject.length > 0"
      >
        <div
          v-for="(item, index) in parentObject"
          :key="index"
          class="truncate"
          :class="currentNode.nodeCode === item.nodeCode ? 'active' : ''"
          @click="handleNodeClick(item)"
        >
          <el-tooltip
            :content="`${item.nodeCode}【${item.nodeName}】`"
            placement="top"
            :open-delay="500"
          >
            <span>{{ item.nodeCode }}【{{ item.nodeName }}】</span>
          </el-tooltip>
        </div>
      </div>
      <!-- 下级对象 -->
      <div class="flex justify-start item-start mb-10px" v-if="subObject.length > 0">
        <CategoryTitle class="mt-5px mb-10px" title="下级对象"></CategoryTitle>
      </div>
      <div
        class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]"
        v-if="subObject.length > 0"
      >
        <div
          v-for="(item, index) in subObject"
          :key="index"
          class="truncate"
          :class="currentNode.nodeCode === item.nodeCode ? 'active' : ''"
          @click="handleNodeClick(item)"
        >
          <el-tooltip
            :content="`${item.nodeCode}【${item.nodeName}】`"
            placement="top"
            :open-delay="500"
          >
            <span>{{ item.nodeCode }}【{{ item.nodeName }}】</span>
          </el-tooltip>
        </div>
      </div>
      <!-- 关联对象 -->
      <div class="flex justify-start item-start mb-10px" v-if="assocTagsList.length > 0">
        <CategoryTitle class="mt-5px mb-10px" title="">关联对象</CategoryTitle>
      </div>
      <div
        class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]"
        v-if="assocTagsList.length > 0"
      >
        <div
          v-for="(item, index) in assocTagsList"
          :key="index"
          class="truncate"
          :class="currentNode.code === item.code ? 'active' : ''"
          @click="handleNodeClick(item)"
        >
          <el-tooltip :content="`${item.code}【${item.name}】`" placement="top" :open-delay="500">
            <span>{{ item.code }}【{{ item.name }}】</span>
          </el-tooltip>
        </div>
      </div>
    </div>

    <!-- 测点定位弹窗 -->
    <PointDialog
      :pointDialog="pointDialog"
      :pointDataHeader="pointDataHeader"
      @closeItem="closeItem"
    />
    <!-- 查看文件弹窗 -->
    <objDialog
      v-if="showDialog"
      width="800px"
      height="550px"
      top="120px"
      left="630px"
      :dialogForm="dialogForm"
      @closeObjInfo="closeObjInfo"
      @splitScreen="splitScreen"
      @svgTrigger="svgTrigger"
      type="dialog"
      :player="player"
      :standardId="standardId"
    />
  </div>
</template>

<script>
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import { IotApi } from '@wiz-api/measuring-point-management'
import dayjs from 'dayjs'
import InfiniteScroll from './InfiniteScroll'
import HandoverService from '../../../service/HandoverService'
import objDialog from './objDialog'
import PointDialog from './PointDialog'

const iotApi = new IotApi()
const baseUrl = Wiz.GetModuleServer()

export default {
  components: {
    CategoryTitle,
    TableButtonGroup,
    InfiniteScroll,
    objDialog,
    PointDialog,
  },
  props: {
    // 显示对象信息的文件弹窗
    showObjInfoDialog: {
      type: Boolean,
      default: false,
    },
    // 移交对象传过来的数据
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: '属性',
      menuList: ['属性', '关联文档', '关联对象'],
      splitShow: false, // 是否显示分屏按钮
      showDialog: false,
      dialogForm: {},
      basicAttrObj: {}, // 基本属性
      entityAttrList: [], // 实体属性
      assocFilesList: [], // 关联文档
      parentObject: [], // 上级对象
      subObject: [], // 下级对象
      assocTagsList: [], // 关联对象
      currentNode: {},
      standardList: [],
      standardId: '',
      dynamicTableData: [],
      classTypeTableData: [],
      dynamicTableGroupData: [],
      codeInfo: {},
      defaultCameraInfo: null, // 默认视角参数
      isExtend: null,
      isPrimary: null,
      extendValue: null,
      flag: null,
      pointDataHeader: new Map([
        ['pointName', '测点名称'],
        ['pointCode', '测点编码'],
        ['realTimeValue', '测点实时值'],
        ['time', '时间'],
      ]),
      pointDataList: [],
      pointDialog: [],
    }
  },
  watch: {
    showObjInfoDialog(newVal) {
      if (newVal) {
        this.showDialog = true
      }
    },
    transferProps: {
      handler(data) {
        if (data && data.code && data.flag === 0) {
          this.getAllInfo(data.code, data.standardId)
          this.standardId = data.standardId
        } else {
          Object.keys(this.$options.data()).forEach((key) => {
            this[key] = this.$options.data()[key]
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    if (this.$route.query.modelInfoId) {
      this.splitShow = true
    }
    // 先点击模型节点，再打开对象信息面板
    const currentModelNodeCode = localStorage.getItem('currentModelNodeCode')
    if (currentModelNodeCode) {
      await this.getStandardList()
      this.getAllInfo(currentModelNodeCode, this.standardId)
    }
  },
  async mounted() {
    this.defaultCameraInfo = await this.player.Native.Camera.currentParam() // 获取默认相机信息
    // 先打开对象信息面板，再点击模型节点
    // 监听选择节点切换事件
    this.player.Native.ModelTree.EventSelectItemChanged.connect(this.watchMsg)
  },
  async beforeDestroy() {
    // 取消选中节点
    await this.player.Native.ModelTree.setSelectItem(0)
    this.player.Native.ModelTree.EventSelectItemChanged.disconnect(this.watchMsg)
    this.resetCamera()
  },
  methods: {
    // 获取测点滚动列表数据
    // 测点列表点击事件
    async handlePointClick(item) {
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(
        decodeURIComponent(item.pointCode)
      ) // 根据code获取模型节点信息
      await this.player.Native.Camera.moveToCode(decodeURIComponent(item.pointCode), 1) // 相机跳转
      await this.player.Native.ModelTree.setSelectItem(codeInfo.item) // 模型选中
      // 重复点击不弹出
      if (
        this.pointDialog.find((e) => {
          return e.pointItem.id === item.id
        })
      ) {
        return
      }
      const dialogItem = {
        pointItem: item,
        visible: true,
        position: {
          top: this.pointDialog.length * 40 + 150,
          left: this.pointDialog.length * 40 + 700,
        },
      }
      this.pointDialog.push(dialogItem)
    },
    closeItem(val) {
      this.pointDialog.includes(val) && this.pointDialog.splice(this.pointDialog.indexOf(val), 1)
    },
    // 获取code的id
    async getCodeId(code, standardId) {
      const [err, res] = await HandoverService.getCodeId({
        standardId,
        code,
        cateCode: 'Tag',
      })
      if (!err && res && res.code === 0 && res.data?.id) {
        this.codeInfo = res.data
        this.getDynamicTableDataById(code, standardId)
        this.getPointList(code)
        this.getPersonalityMetaAttr(standardId)
        this.getAssociatedFiles(this.codeInfo.id, standardId)
        this.getParentAndSubObj(this.codeInfo.id, standardId)
        this.getAssociatedTags(this.codeInfo.id, standardId)
      } else {
        this.codeInfo = {}
      }
    },
    async getPersonalityMetaAttr(mStandardId) {
      const [dErr, dRes] = await HandoverService.getPersonalityMetaDefine({
        standardId: mStandardId,
        stdPersonalityMetaDataType: 1,
        columnName: 'Delivery_level',
      })
      if (!dErr && dRes && dRes.code === 0 && dRes.data) {
        const [err, res] = await HandoverService.getPersonalityMetaData({
          classId: this.codeInfo.class_id,
          stdPersonalityMetaDataId: dRes.data[0]?.id,
        })
        if (!err && res && res.code === 0 && res.data) {
          this.personalityMetaAttr = res.data
        }
      }
    },
    // 获取动态表单数据by id
    async getDynamicTableDataById(code, standardId) {
      const [err, res] = await HandoverService.getDynamicTableData({
        classId: this.codeInfo.class_id,
        dataId: this.codeInfo.id,
      })
      if (!err && res && res.code === 0 && res.data) {
        this.dynamicTableData = res.data
        this.getClassTypeTableHeader(code, standardId)
        this.getDynamicTableGroupHeader()
      } else {
        this.dynamicTableData = []
      }
    },
    // 获取测点id列表
    async getPointList(code) {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/point_by_class_code/V1.0?token=portal_js&code=${code}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          this.pointDataList = _.cloneDeep(
            res.data.data.map((item) => {
              return {
                id: item.id,
                pointId: item.pointId.toString(),
                pointName: item.name,
                pointCode: item.code,
                realTimeValue: '',
                time: '',
              }
            })
          )
          const idList = this.pointDataList.map((item) => {
            return item.pointId
          })
          idList.length > 0 && this.getValueForMeasuringPoints(idList)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 测点id获取iot实时数据列表
    async getValueForMeasuringPoints(idList) {
      const params = {
        ids: idList.join(','),
      }
      const [err, res] = await iotApi.getValueForMeasuringPoints(params)
      if (!err) {
        this.pointDataList.forEach((item) => {
          for (let i = 0; i < res.data.length; i += 1) {
            if (item.pointId === res.data[i].measuringPointId) {
              item.realTimeValue = res.data[i].values[0].value.toFixed(2)
              item.time = dayjs(
                Number(res.data[i].values[0].timeStamp.toString().padEnd(13, '0'))
              ).format('YYYY-MM-DD HH:mm:ss')
            }
          }
        })
      }
    },
    // 获取实体类型动态表头
    async getClassTypeTableHeader(code, standardId) {
      if (!this.codeInfo.class_id) return
      const [err, res] = await HandoverService.getClassTypeTableHeader({
        standardId,
        classId: this.codeInfo.class_id,
        cateCode: 'Tag',
      })
      if (!err && res && res.code === 0 && res.data) {
        this.classTypeTableData = res.data
        Object.keys(this.dynamicTableData).forEach((key) => {
          _.map(this.classTypeTableData, (item) => {
            if (key === `${item.tableName}.${item.columnName}`) {
              item.value = this.dynamicTableData[key]
            }
            if (item.isPrimary) this.isPrimary = item
            return item
          })
        })
      } else {
        this.classTypeTableData = []
      }
    },
    // 获取实体分组动态表头
    async getDynamicTableGroupHeader() {
      if (!this.codeInfo.class_id) return
      const [err, res] = await HandoverService.getDynamicTableGroupHeader({
        classId: this.codeInfo.class_id,
      })
      if (!err && res && res.code === 0 && res.data) {
        this.dynamicTableGroupData = res.data
        Object.keys(this.dynamicTableGroupData).forEach((groupKey) => {
          Object.keys(this.dynamicTableData).forEach((key) => {
            _.map(this.dynamicTableGroupData[groupKey], (item) => {
              if (key === `${item.tableName}.${item.columnName}`) {
                const deliveryLevel = this.personalityMetaAttr?.find((e) => {
                  return e.relationId === item.id
                })?.dataValue
                item.value = this.dynamicTableData[key]
                item.show = !(deliveryLevel === '选填' && item.value == null)
              }
              return item
            })
          })
          this.dynamicTableGroupData[groupKey].forEach((obj) => {
            if (obj.isExtend === 1) this.isExtend = obj
          })
        })
        if (this.isExtend) {
          await this.getExtensionList()
          await this.getExtendDataList()
        }
      } else {
        this.dynamicTableGroupData = []
      }
    },
    // 获取扩展属性下拉数据
    async getExtensionList() {
      const [err, res] = await HandoverService.getExtendClassList({
        classId: this.isExtend.classId,
      })
      if (!err && res && res.code === 0) {
        this.extendValue = res.data.find((item) => {
          return item.extendClassCode === this.isExtend.value
        })
      }
    },
    // 模型点选
    async watchMsg(e) {
      console.log(e, '家具打个包')

      if (e?.code) {
        // await this.getStandardList()
        this.getAllInfo(e.code, this.standardId)
      }
    },
    getAllInfo(code, standardId) {
      this.getCodeId(code, standardId)
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardList = res.data
        this.standardId = res.data[0].id
      } else {
        this.standardList = []
        this.standardId = ''
      }
    },
    tabChange(item) {
      this.activeTab = item
    },
    openDialog(val) {
      if (val.defaultFileId && val.defaultFileId.includes('http')) {
        window.open(val.defaultFileId)
        return
      }
      this.showDialog = false
      this.$nextTick(() => {
        this.showDialog = true
      })
      this.dialogForm = _.cloneDeep(val)
    },
    closeObjInfo() {
      this.showDialog = false
    },
    // 分屏
    splitScreen(val) {
      this.showDialog = false
      const obj = {
        width: document.documentElement.clientWidth / 2,
        height: document.documentElement.clientHeight - 100,
        dialogForm: val,
        standardId: this.standardId,
      }
      this.sendInfoToRightDialog('mainComponent', obj)
    },
    realSplitScreen(val) {
      this.showDialog = false
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectFileSplit', origin: 'ObjectInfo', name: '移交对象' },
        props: {
          formData: val,
          standardId: this.standardId,
        },
      })
    },
    // 获取关联文档
    async getAssociatedFiles(id, standardId) {
      if (!id) return
      const [err, res] = await HandoverService.getAssociatedFiles({ id, standardId })
      if (!err && res && res.code === 0 && res.data) {
        this.assocFilesList = res.data
      } else {
        this.assocFilesList = []
      }
    },
    // 获取上下级对象
    async getParentAndSubObj(id, standardId) {
      if (!id) return
      const [err, res] = await HandoverService.getParentAndSubObj({ id, standardId })
      if (!err && res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          if (item.nodeName === '上级对象') {
            this.parentObject = item.childrenNodes
          }
          if (item.nodeName === '下级对象') {
            this.subObject = item.childrenNodes
          }
        })
      } else {
        this.parentObject = []
        this.subObject = []
      }
    },
    // 获取关联对象
    async getAssociatedTags(id, standardId) {
      if (!id) return
      const [err, res] = await HandoverService.getAssociatedTags({
        keyword: '',
        sort: 'created_time desc',
        pageIndex: 1,
        pageSize: 999,
        standardId,
        id,
      })
      if (!err && res && res.code === 0 && res.data) {
        this.assocTagsList = res.data
      } else {
        this.assocTagsList = []
      }
    },
    // 传递信息给移交对象
    sendInfoToRightDialog(type, data = {}) {
      this.$emit('transferEvent', {
        toCom: { code: 'HandoverObject', origin: 'ObjectInfo', name: '移交对象' },
        type,
        props: {
          ...data,
          openAlarmFlicker: true,
          flickerFrequency: 500,
        },
      })
    },
    // 点击节点
    async handleNodeClick(node) {
      this.currentNode = node
      if (node.nodeCode || node.code) {
        // 通过位号查找节点
        const codeInfo = await this.player.Native.ModelTree.getItemByCode(
          decodeURIComponent(node.nodeCode || node.code)
        )
        if (codeInfo && codeInfo.item) {
          this.sendInfoToRightDialog('mainComponent', node)
          // 设置当前选中节点，不触发事件
          this.player.Native.ModelTree.setSelectItem(codeInfo.item)
          // 设置点选时其他节点半透明
          this.player.Native.Settings.set('color.pickup.bkAlpha', 'float', 0.4)
          // 外层添加包裹盒子
          this.player.Native.Settings.set('pickup.highlight', 'bool', true)
          this.player.Native.Settings.set('show.select.box', 'bool', true)
          // 计算节点包围盒
          const { aabb, localMatrix } = await this.player.Native.ModelTree.calcItemAabb(
            codeInfo.item
          )
          // 相机移动到包围盒位置
          this.player.Native.Camera.addMoveToAabb(aabb, localMatrix, 5, 1.1, 2)
        }
      }
    },
    // 点击svg触发事件
    svgTrigger(val) {
      console.log(val, 'svgTrigger111')
      // 点击Svg空白处时不触发事件，避免传空值导致接口返回错误数据
      if (val.code) {
        this.getCodeId(val.code, this.standardId)
      } else {
        this.codeInfo = {}
      }
    },
    // 恢复相机
    async resetCamera() {
      await this.player.Native.Camera.moveTo(
        this.defaultCameraInfo.eye,
        this.defaultCameraInfo.target,
        this.defaultCameraInfo.up,
        1
      )
    },
    resetScrollHeight() {
      this.$refs.infiniteScrollRef.height = 0
    },
  },
}
</script>

<style lang="scss" scoped>
.active {
  background: #005d657f !important;
}
.point-item-bg {
  background-image: url('./images/测点详情bg@1x.png');
  background-size: 100% 100%;
}
</style>
